(function reactHydrationCheck() {
  const { body } = document;
  let hydrationCheckStarted = false;

  function allComponentsHydrated() {
    const components = document.getElementsByTagName('react-component');
    const componentCount = components.length;

    if (componentCount === 0) {
      return true;
    }

    // Check if all React components have been hydrated
    const hydratedComponents = Array.from(components).filter((component) => {
      const hasChildren = component.children.length > 0;
      const hasTextContent = component.textContent && component.textContent.trim().length > 0;

      // React attaches internal properties to DOM nodes it manages
      const hasReactInternals = Object.keys(component).some(
        (key) => key.startsWith('__react') || key.startsWith('_react'),
      );

      // Require children, content, and React internals to prevent flashing
      return hasChildren && hasTextContent && hasReactInternals;
    });

    return hydratedComponents.length === componentCount;
  }

  function showPage() {
    if (body) {
      body.classList.remove('page-content-hidden');
    }
  }

  function startHydrationCheck() {
    // Prevent multiple calls from creating multiple polling intervals
    if (hydrationCheckStarted) {
      return;
    }
    hydrationCheckStarted = true;

    // Set up polling to check for React components
    let checkCount = 0;
    const maxChecks = 30; // Maximum 3 seconds (30 * 100ms)

    const checkInterval = setInterval(() => {
      checkCount += 1;

      if (allComponentsHydrated() || checkCount >= maxChecks) {
        clearInterval(checkInterval);
        showPage();
      }
    }, 100);
  }

  // Wait for custom element to be defined, then start checking
  // The polling mechanism handles waiting for content to appear
  customElements.whenDefined('react-component').then(() => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startHydrationCheck);
    } else {
      startHydrationCheck();
    }
  });
})();
